import { render, staticRenderFns } from "./SupplierPopup.vue?vue&type=template&id=e52c4b94&scoped=true&"
import script from "./SupplierPopup.vue?vue&type=script&lang=js&"
export * from "./SupplierPopup.vue?vue&type=script&lang=js&"
import style0 from "./SupplierPopup.vue?vue&type=style&index=0&id=e52c4b94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52c4b94",
  null
  
)

export default component.exports